// extracted by mini-css-extract-plugin
export default {"adminsListHeader":"admins-list_adminsListHeader__6qAby","actions":"admins-list_actions__3rcTq"};